import { useState } from "react";
import { adminApi as api, extractErrorMessage } from "../../../util/api";
import { useCallback } from "react";
import { snakifyKeys } from "../../../util/helpers";
import { Button, Modal, ModalBody, ModalHeader } from "reactstrap";
import { DetailedErrorAlert } from "../../../components/DetailedErrorAlert";
import { Form } from "react-final-form";
import { SpecialProjectCaseAssignmentForm } from "./SpecialProjectCaseAssignmentForm";

export const CreateSpecialProjectCaseAssignmentModal = ({ onAdd, ...rest }) => {
  const [open, setOpen] = useState(false);
  const [error, setError] = useState(null);

  const toggleModal = () => setOpen((x) => !x);

  const handleCreate = useCallback(
    async (params) => {
      setError(null);

      try {
        const res = await api.post(
          "/admin/special_project_case_assignment_configs",
          snakifyKeys({
            special_project_case_assignment_config: params,
          })
        );

        if (onAdd) {
          onAdd(res.data?.meta?.message, res.data?.meta?.error_details);
        }

        setOpen(false);
      } catch (err) {
        setError(extractErrorMessage(err));
      }
    },
    [onAdd]
  );

  return (
    <>
      <Button onClick={toggleModal} {...rest}>
        Add New Special Project Case Assignment
      </Button>

      <Modal size="lg" isOpen={open} toggle={toggleModal}>
        <ModalHeader toggle={toggleModal}>Add New Special Project Case Assignment</ModalHeader>

        <ModalBody>
          <DetailedErrorAlert error={error} />

          <Form onSubmit={handleCreate} initialValues={{}}>
            {(props) => <SpecialProjectCaseAssignmentForm {...props} />}
          </Form>
        </ModalBody>
      </Modal>
    </>
  );
};
